import axios from 'axios';

export const UPLOAD_EXCEL_FILE = 'completeAgentsDetails/uploadExcelFile';

export function uploadFile({formData}) {
  return axios.post(UPLOAD_EXCEL_FILE, formData, {
    headers: {
      'content-type': 'multipart/form-data'
    }
  });
}
